import React from "react";
import { App as Map } from "@iventis/embedded-map/src/app";

export const MapPerformanceComponent = () => (
    <div style={{ height: "100vh", width: "100vw" }}>
        <Map />
    </div>
);

export default MapPerformanceComponent;
